<template>
  <!-- The Modal -->
  <div
      id="editModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Edit Phase"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="value">Name «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="name"
                          rules="required"
                      >
                        <b-form-input
                            id="name"
                            name="name"
                            v-model="updatedPhase.title"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="value">Name «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="nameAR"
                          rules="required"
                      >
                        <b-form-input
                            id="nameAR"
                            class="arabic-font"
                            name="nameAR"
                            v-model="updatedPhase.titleAR"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                            dir="rtl"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="textarea-default">Description  «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Description En"
                          rules="required"
                      >
                        <template>
                          <b-form-textarea
                              id="textarea-default"
                              v-model="updatedPhase.description"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              placeholder="Textarea"
                              rows="5"
                              cols="12"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="descriptionAR">Description  «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          description_ar
                          name="Description AR"
                          rules="required"
                      >
                        <b-form-textarea
                            id="descriptionAR"
                            v-model="updatedPhase.descriptionAR"
                            class="arabic-font"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            placeholder=""
                            rows="5"
                            cols="12"
                            :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { codeBasic } from './code'
import stagePhasesService from '@/services/settings/stagePhasesService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BForm,
    BRow,
    BCol,
  },
  props: ['phase'],
  data() {
    return {
      updatedPhase: {
        id: '',
        title: '',
        titleAR: '',
        description: '',
        descriptionAR: '',
      },
      codeBasic,
    }
  },
  mounted() {
    this.$watch(() => this.phase, val => {
      /* Init Updated Object (Which will be sent To API) */
      this.updatedPhase = {
        id: val.id,
        title: val.title,
        titleAR: val.titleAR,
        description: val.description,
        descriptionAR: val.descriptionAR,
      }
    })
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          console.log('wow', this.updatedstage)
          stagePhasesService.put(this.updatedPhase).then(response => {
            this.$emit('refresh', 'true')

            $('#editModal').modal('hide')
            if (response && response.status === 200) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: 'Phase Is Updated Successfully !',
                },
              })
            }
            this.loading = false
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
label{
  font-weight: bold;
}
</style>
